import {pluralNumber} from '../../../utils/numerals/pluralNumber';

export const initPayBack = () => {

	const component = document.querySelectorAll('.payback-calculator');

	if ( !component.length ) {
		return;
	}

	if ( component ) {
		(function () {

			function ctrls( element, count_step, counter = 0, maxLength = 9999999999 ) {
				let _this = this;
				this.counter = counter;
				this.els = {
					decrement: element.querySelector(".button-decrement"),
					counter: {
						num: element.querySelector(".counter"),
						input: element.querySelector(".counter-input"),
					},
					increment: element.querySelector(".button-increment"),
				};
	
				this.decrement = function () {
					let counter = _this.getCounter();
					let nextCounter = _this.counter > 0 ? counter - count_step : counter;
					_this.setCounter(nextCounter);
				};
	
				this.increment = function () {
					let counter = _this.getCounter();
					let nextCounter = counter < maxLength ? counter + count_step : counter;
					_this.setCounter(nextCounter);
				};
	
				this.getCounter = function () {
					return _this.counter;
				};
	
				this.setCounter = function (nextCounter) {
					_this.counter = nextCounter;
				};
	
				this.debounce = function (callback) {
					setTimeout(callback, 100);
				};
	
				this.render = function (hideClassName, visibleClassName) {
					_this.els.counter.num.classList.add(hideClassName);
	
					setTimeout(function () {
						_this.els.counter.num.innerText = _this.getCounter();
						_this.els.counter.input.value = _this.getCounter();
						_this.els.counter.num.classList.add(visibleClassName);
					}, 10);
	
					setTimeout(function () {
						_this.els.counter.num.classList.remove(hideClassName);
						_this.els.counter.num.classList.remove(visibleClassName);
					}, 110);
				};
	
				this.ready = function () {
					_this.els.decrement.addEventListener("click", function () {
						_this.debounce(function () {
							_this.decrement();
							_this.render("is-decrement-hide", "is-decrement-visible");
						});
					});
	
					_this.els.increment.addEventListener("click", function () {
						_this.debounce(function () {
							_this.increment();
							_this.render("is-increment-hide", "is-increment-visible");
						});
					});
	
					_this.els.counter.input.addEventListener("input", function (e) {
						let parseValue = parseInt(e.target.value);
						if (!isNaN(parseValue) && parseValue >= 0) {
							_this.setCounter(parseValue);
							_this.render();
						}
					});
				};
			};
	
			if (component) {
				component.forEach(element => {
					let inputArend = element.querySelector('.input-arend');
					let inputProc = element.querySelector('.input-proc');
					let initValueBase = document.querySelector('input.rate').value;
					const initValue = Number(atob(initValueBase));
					const controls = new ctrls( inputArend, 500, initValue );
					const controls_2 = new ctrls( inputProc, 1, 1, 100 );

					document.addEventListener("DOMContentLoaded", controls.ready);
					document.addEventListener("DOMContentLoaded", controls_2.ready);
				});

				const buildPriceValue = document.querySelector('input.total').value;
				const areasValue = document.querySelector('input.square').value;

				const buildPrice = Number(atob(buildPriceValue));
				const areas = Number(atob(areasValue));

				const inputRents = document.querySelector('.input-arend>input');
				const inputProc = document.querySelector('.input-proc');
				const incrRents = document.querySelector('.input-arend>.plus');
				const decrRents = document.querySelector('.input-arend>.minus');

				const decrProc = document.querySelector('.input-proc>.minus');

				let what = +document.querySelector('.input-arend>.count>.rents').innerText;

				inputProc.querySelector('input').setAttribute('disabled', 'disabled');

				const procent = inputProc.querySelector('.counter');
	
				const calculationValue = () => {

					const textBox = document.querySelector('.content');

					const procentFormular = (( buildPrice * +procent.outerText ) / 100);

					
		
					const valueFirst =  ( buildPrice - (procentFormular ));
					const valueSecond = ( areas * ( what ) );
					const valueFinale = ( valueFirst / valueSecond ) / 12 ;

					const calculatorRedit = valueFinale.toFixed(1).toString().indexOf('.');
					const yearItem = valueFinale.toFixed(1).toString().slice( 0, calculatorRedit);
					const mountsItem = valueFinale.toFixed(1).toString().slice( calculatorRedit ).replace( /[\s.,%]/g, '' );


					

					if ( what === 500 ) {
						decrRents.setAttribute('disabled', 'disabled');
					}

					if ( procent.outerText === '1' ) {
						decrProc.setAttribute('disabled', 'disabled');
					}

					setTimeout( () => {
						let textMount = `&nbsp;месяцев`;
						
						let textYears = `&nbsp;лет`;

						what = +document.querySelector('.input-arend>.count>.rents').innerText;
						textBox.innerHTML = `${yearItem}${pluralNumber( Number(yearItem), '&nbsp;год', '&nbsp;года', '&nbsp;лет' )}, ${mountsItem}${pluralNumber( Number(mountsItem), '&nbsp;месяц', '&nbsp;месяца', '&nbsp;месяцев' )}`;

						if ( mountsItem === '0' )
						{
							textMount = '';
							textBox.innerHTML = `${yearItem}${pluralNumber( Number(yearItem), '&nbsp;год', '&nbsp;года', '&nbsp;лет' )}`;
						}

						if ( yearItem === '0' )
						{
							textYears = '';
							textBox.innerHTML = `${mountsItem}${pluralNumber( Number(mountsItem), '&nbsp;месяц', '&nbsp;месяца', '&nbsp;месяцев' )}`;
						}

						
						
						calculationValue();

					}, 0)

					inputRents.setAttribute('disabled', 'disabled');
				};
		
				incrRents.addEventListener('click', calculationValue);
				decrRents.addEventListener('click', calculationValue);
	
				calculationValue();

				const linkPayBack = document.querySelector( 'a.scroll-to' );

				if ( linkPayBack ) {
					linkPayBack.addEventListener('click', function(e) {
						e.preventDefault();
				
						const scrollTarget = document.querySelector('.payback-calculator');
				
						const topOffset = document.querySelector('.scroll-to').offsetHeight;

						const elementPosition = scrollTarget.getBoundingClientRect().top;
						const offsetPosition = elementPosition - 115;
				
						window.scrollBy({
							top: offsetPosition,
							behavior: 'smooth'
						});
					});
				}
			};
	
		})();
	};
};
